import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import typeConstant from '../../constants/types.constant'
import AbstractCollection from '../Abstract/AbstractCollection'

// Phase 2 — listing view for the 14 static-page metadata records. Filtering
// by `type=page` keeps this list separate from blog/service/etc collections.
const Pages = function () {
  return (
    <AbstractCollection
      collectionName="Pages"
      singleCollectionName="Page"
      notToShow={[
        'ancestorIds',
        'parentId',
        'type',
        'featured',
        'coverPhoto',
        'images',
        'videos',
        ...SLIDE_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
      toShow={['name', 'id', 'status', 'createdAt']}
      type={typeConstant.PAGE}
    />
  )
}
export default Pages
